<template>
  <nav-bar/>
  <router-view />
</template>
<script>
import navBar from './components/navBar.vue';
export default {
  components: {
    navBar,
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Teko:wght@300;400;500;600;700&display=swap');
@import '../src/assets/css/main.css';
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
